import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introLeftVariants } from '@/config/const'
import { getWhySezBanner } from '@/services/why-sez'
import { useAppSelector } from '@/utils/hooks'

import noiseTexture from '~/assets/images/investment/why-invest/noise-texture.webp'
import Ornament from '~/assets/images/investment/why-invest/why-invest-banner-ornament.svg'

const Banner: FC<{ handleToSectionTwo: () => void }> = ({ handleToSectionTwo }) => {
  const router = useRouter()
  const { t } = useTranslation()
  const { data: banner } = useAppSelector(
    getWhySezBanner.select({
      headers: { 'Accept-Language': String(router.locale) },
    })
  )

  if (banner) {
    return (
      <div className='banner-container'>
        <div className='absolute inset-0 '>
          <div className='absolute hidden h-full w-4/5 bg-[#fffff6] lg:block' />
          <img
            src={noiseTexture.src}
            alt='Noise Texture'
            className='w-full object-cover opacity-5'
          />
        </div>

        <motion.div
          className='relative z-10 flex w-full flex-col items-center gap-6 px-4 text-center md:w-[479px] md:px-0 lg:items-start lg:gap-10 lg:text-left'
          initial='hide'
          whileInView='show'
          exit='hide'
          variants={introLeftVariants}
          viewport={{ once: true }}
        >
          <div className='gap2.5 flex flex-col'>
            <p className='mb-2.5 flex flex-col items-center gap-2.5 text-base font-medium leading-7 text-red after:h-1 after:w-6 after:rounded-full after:bg-red lg:items-start lg:gap-[17px] lg:text-lg'>
              {banner.data.subTitle ?? '-'}
            </p>

            <div className='flex flex-col gap-3 lg:gap-6'>
              <h2 className='w-full text-[33px] font-extrabold uppercase leading-[41px] text-gray-1 lg:w-[400px] lg:text-[55px] lg:leading-[normal]'>
                {banner.data.title ?? '-'}
              </h2>
              <div
                className='text-lg leading-7 text-gray-1'
                dangerouslySetInnerHTML={{ __html: banner.data.description ?? '' }}
              />
            </div>
          </div>

          <button
            className='flex w-fit items-center gap-2 rounded-full bg-red px-6 py-3 text-white'
            onClick={handleToSectionTwo}
          >
            <span className='font-bold'>{t('investment-why-invest:scrollForDetails')}</span>
            <span className='kek-arrow-right rotate-90' />
          </button>
        </motion.div>

        <div className='banner-first-container'>
          {banner?.data.imageFiles.first && (
            <ImageByWidthDevice
              images={banner?.data.imageFiles.first ?? ''}
              alt='banner image 1'
              className='banner-first-images'
            />
          )}
        </div>

        <div className='banner-second-container'>
          {banner?.data.imageFiles.second && (
            <ImageByWidthDevice
              images={banner?.data.imageFiles.second ?? ''}
              alt='banner image 2'
              className='banner-second-images'
            />
          )}
        </div>

        <div className='banner-ornament'>
          <Ornament className='banner-ornament-image' />
        </div>
      </div>
    )
  }
  return null
}

export default Banner
